import makeRequest from '@utilities/make-xhr';

export default class FooterSubscribeForm {
    constructor(context) {
        this.context = context;

        this.context.addEventListener('submit', this.sendSubscribe);
    }

    sendSubscribe(event) {
        event.preventDefault();

        const form = this;
        const { action } = form;
        const mes = form.querySelector('[data-rander="response"]');
        const email = form.querySelector('input[type=email]').value;
        const data = {
            email,
        };

        makeRequest('POST', action, data).then(
            resp => {
                const respParse = JSON.parse(resp);

                form.classList.add('response');
                mes.innerHTML = respParse.message;

                setTimeout(() => {
                    form.classList.remove('response');
                }, 3000);

                try {
                    // eslint-disable-next-line no-undef
                    ga('send', 'event', 'subscribeMail', 'podpiska_m');
                    // eslint-disable-next-line no-undef
                    yaCounter1925770.reachGoal('podpiska_m');
                } catch (error) {
                    console.log(error);
                }
            },
            error => {
                console.error('error', error);
            }
        );
    }
}
